import { styled } from '@mui/material';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100vh',
});

export const Content = styled('div')({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  padding: 16,
  overflowY: 'auto',
  gap: 16,
});
